import React from "react";

const TONE_CLASSES = {
  sky: "text-sky-700 bg-sky-100 dark:bg-sky-500/10 dark:text-sky-200",
  blue: "text-blue-700 bg-blue-100 dark:bg-blue-500/10 dark:text-blue-200",
  emerald:
    "text-emerald-700 bg-emerald-100 dark:bg-emerald-500/10 dark:text-emerald-200",
  amber:
    "text-amber-700 bg-amber-100 dark:bg-amber-500/10 dark:text-amber-200",
  orange:
    "text-orange-700 bg-orange-100 dark:bg-orange-500/10 dark:text-orange-200",
  slate:
    "text-slate-700 bg-slate-100 dark:bg-white/10 dark:text-white/70",
};

function StatistiqueCard({
  icon: Icon,
  label,
  value,
  description,
  tone = "sky",
}) {
  return (
    <article className="rounded-[1.75rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 transition hover:-translate-y-1 hover:shadow-2xl dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="flex items-start justify-between gap-4">
        <div
          className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ${
            TONE_CLASSES[tone] || TONE_CLASSES.sky
          }`}
        >
          {Icon && <Icon className="text-xl" />}
        </div>

        <p className="text-right font-titre text-3xl font-bold text-slate-950 dark:text-white">
          {value}
        </p>
      </div>

      <h3 className="mt-4 text-sm font-bold text-slate-800 dark:text-white">
        {label}
      </h3>

      {description && (
        <p className="mt-2 text-xs font-medium leading-5 text-slate-500 dark:text-white/45">
          {description}
        </p>
      )}
    </article>
  );
}

export default StatistiqueCard;